import React from "react"
import {
  ThemeProvider,
  CssBaseline,
  Paper,
  Typography,
  Box,
} from "@material-ui/core"
import { createMuiTheme } from "@material-ui/core/styles"
import styles from "./UserApplicationSuccessPage.module.scss"

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
})

const UserApplicationSuccessPage = () => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className={styles.container}>
        <div className={styles.content}>
          <Paper className={styles.paper}>
            <Box className={styles.successMessageContainer}>
              <Typography variant="h5" className={styles.successTitle}>
                🎉 Congratulations!
              </Typography>
              <Typography variant="body1" className={styles.successMessage}>
                Your application has been submitted successfully.
                <br /> Our team will review your submission and you will receive a
                confirmation email shortly with next steps.
              </Typography>
              <Typography variant="body2" className={styles.successNote}>
                Thank you for your interest in joining our platform.
                <br /> We appreciate your patience during the review process.
              </Typography>
            </Box>
          </Paper>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default UserApplicationSuccessPage
